import { unwrap } from '@ff-os/shared-utils/unwrap';
import { GiftJson } from '../../../GiftJson';
import { matchActiveVariant } from '../../../matchActiveVariant';
import { toActiveInputs } from '../../../toActiveInputs';

export const addActiveVariantIdToMeta = (project: any): any => {

    const allVariants = unwrap<GiftJson.Variant<any>>(project.variants);
    const activeInputs = toActiveInputs(project.variables.ids, project.inputs.entities);
    const activeVariant = matchActiveVariant(allVariants, activeInputs);

    return {
        ...project,
        meta: {
            ...project.meta,
            activeVariantId: activeVariant.id
        }
    };
};